import React, { useState, useRef, useEffect } from "react";
import { Image } from "react-bootstrap";
import { LayoutHome } from "../LayoutHome";
import { Text } from "rsuite";
import { useParams } from "react-router-dom";
import { getFirmaConsentimiento } from "../Services/PacientesServices";
import moment from "moment/moment";

export const AplicacionHierro = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [anios, setAnios] = useState("");
  const [firma, setFirma] = useState("");
  const [idMedico, setIdMedico] = useState("");
  const [medico, setMedico] = useState("");
  const [firmaDoctor, setFirmaDoctor] = useState("");
  const [testigo1, setTestigo1] = useState("");
  const [firmaTestigo1, setFirmaTestigo1] = useState("");
  const [testigo2, setTestigo2] = useState("");
  const [firmaTestigo2, setFirmaTestigo2] = useState("");
  const [fechaFirma, setFechaFirma] = useState("");
  const { idPaciente, paciente } = useParams();
  const initialized = useRef(false);

  const getFirma = async () => {
    await getFirmaConsentimiento(idNegocio, idPaciente, "AplicaHierro")
      .then((res) => {
        setFirma(res.firmaPac);
        setIdMedico(res.idMedico);
        setMedico(res.medico);
        setAnios(res.anios);
        setFirmaDoctor(res.firmaDr);
        setTestigo1(res.testigo1);
        setFirmaTestigo1(res.firmaTestigo1);
        setTestigo2(res.testigo2);
        setFirmaTestigo2(res.firmaTestigo2);
        setFechaFirma(res.fechaFirma);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getFirma();
    }
  }, []);

  return (
    <div>
      <title>Consentimiento de Aplicación de Hierro</title>
      <Image
        src={`/Images/Negocios/${idNegocio}/cornerImageHoja.png`}
        style={{
          width: "450px",
          position: "absolute",
          right: "0%",
          top: "0%",
          zIndex: "-1",
        }}
      />
      <div
        style={{
          marginLeft: "200px",
          marginTop: "50px",
          marginRight: "200px",
          marginBottom: "50px",
        }}
      >
        <div className="row mb-1">
          <div className="col-lg-3 col-md-3 col-sm-3">
            <Image
              src={`/Images/Negocios/${idNegocio}/Logo.png`}
              height={"80ox"}
            />
          </div>
        </div>
        <div className="row mb-4">
          <div className="text-center col">
            <br></br>
            <br></br>
            <Text size={"2xl"}>
              CONSENTIMIENTO INFORMADO PARA <b>LA APLICACIÓN DE HIERRO IV.</b>
            </Text>
          </div>
        </div>
        <br></br>
        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify " }}>
            <table width={"100%"} style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td style={{ width: "25%" }}>
                    <b>Nombre del paciente:</b>
                  </td>
                  <td
                    style={{
                      width: "50%",
                      borderBottom: "solid 1px",
                      textAlign: "center",
                    }}
                  >
                    {paciente}
                  </td>
                  <td style={{ textAlign: "center" }}>Edad</td>
                  <td
                    style={{
                      width: "10%",
                      borderBottom: "solid 1px",
                      textAlign: "center",
                    }}
                  >
                    {anios}
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            En los pacientes en hemodiálisis, alcanzar los objetivos de
            hemoglobina mejora la calidad de vida y Disminuye la mortalidad y el
            riesgo de hospitalización. En estos pacientes es muy difícil
            alcanzar los valores deseados de hemoglobina si no se utiliza hierro
            intravenoso de forma regular, hecho recogido por las qu(as KDOQUI de
            la NKF.
          </div>
        </div>
        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            Su médico cree necesario la aplicación de hierro intravenoso, debido
            a que el difícil de hierro es tan Común en los pacientes de
            hemodiálisis, se debe usar en la mayoría de los casos 100mg de
            hierro intravenoso semanal o en su defecto el déficit de este según
            formula de corrección.
          </div>
        </div>
        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            El uso regular de hierro parenteral en los pacientes en hemodiálisis
            produce un aumento de hemoglo-bina y, por lo tanto, una disminuci6n
            del requerimiento de eritropoyetina. Esta aplicación puede presentar
            efectos adversos que pueden ser: a) Reacciones retardadas (1-2
            días), caracterizadas por uno o más de los siguientes síntomas:
            artralgia, dolor de espalda, escalcfrió, vértigo, fiebre moderada a
            elevada, cefalea, malestar general, mialgia, náuseas y vomito. Y
            otras más graves que ponen en peligro su vida: b) Reacciones fatales
            y severas, que ocurren con mayor frecuencia en los primeros minu-tos
            de la administración por lo general, se han caracterizado por un
            inicio repentino en la dificultad para respirar y/o colapso
            cardiovascular tales como: Dolor de pecho, opresión en el pecho,
            choque, hipotensión, hipertensión, taquicardia, arritmias, prurito,
            erupción, convulsiones, cefalea, debilidad, episodios febriles,
            escalofríos, vértigo, paro respiratorio, disnea y broncoespasmo.
          </div>
        </div>

        <br></br>
        <br></br>

        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            <table width={"100%"} style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td colSpan={3}>
                    Declaro que he s i do informado por los médicos que me van
                  </td>
                </tr>
                <tr>
                  <td>atender: Dr/Dra.</td>
                  <td style={{ width: "50%", borderBottom: "solid 1px" }}>
                    {medico}
                  </td>
                  <td>de la aplicación de </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    HIERRO DEXTRAN VÍA INTRAVENOSA DURANTE SU SESIÓN DE
                    HEMODIÁLISIS, igualmente de los beneficios
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    que se esperan de su aplicación y de los riesgos que
                    comporta su realización. He comprendido{" "}
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    toda la información y de los riesgos que comporta su
                    realización. He comprendido toda la información que se me ha
                    proporcionado y mis dudas han sido resueltas.
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <br></br>

        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            En consecuencia doy mi consentimiento a que me apliquen hierro
            dextran, y les autorizo a tomar las Medidas oportunas en caso de
            complicaciones para mantenerme con vida o evitarme daño. Sé que en
            cualquier momento puedo revocar mi decisión.
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-2 col-md-2 col-sm-2">
            <br></br>
            <br></br>
            <br></br>
            Firma del paciente
          </div>
          <div
            className="col-lg-4 col-md-4 col-sm-4"
            style={{ borderBottom: "solid 1px" }}
          >
            <img
              src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firma}`}
              alt="signature"
              style={{
                height: "100px",
                zIndex: "-1",
              }}
            />
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <br></br>
            <br></br>
            <br></br>
            Firma del médico
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "solid 1px" }}
          >
            {firmaDoctor !== "" ? (
              <img
                src={`Unidades/${idNegocio}/Medicos/${idMedico}/${firmaDoctor}`}
                alt="signature"
                style={{
                  height: "100px",
                  zIndex: "-1",
                }}
              />
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-3 col-md-3 col-sm-3">
            <br></br>
            <br></br>
            <br></br>
            Firma testigo 1
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "solid 1px" }}
          >
            <img
              src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firmaTestigo1}`}
              alt="signature"
              style={{
                height: "100px",
                zIndex: "-1",
              }}
            />
          </div>
          <div className="text-center col-lg-3 col-md-3 col-sm-3">
            <br></br>
            <br></br>
            <br></br>
            Firma testigo 2
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "solid 1px" }}
          >
            {firmaTestigo2 !== "" ? (
              <img
                src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firmaTestigo2}`}
                alt="signature"
                style={{
                  height: "100px",
                  zIndex: "-1",
                }}
              />
            ) : (
              ""
            )}
          </div>
        </div>

        <br></br>
        <div className="row mb-2">
          <div className="col">
            <table width={"60%"} style={{ width: "60%" }}>
              <thead>
                <tr>
                  <td style={{ width: "28%" }}>Guadalajara, Jalisco</td>
                  <td>a</td>
                  <td
                    style={{ textAlign: "center", borderBottom: "solid 1px" }}
                  >
                    {moment(fechaFirma).format("DD")}
                  </td>
                  <td style={{ textAlign: "center" }}>del mes</td>
                  <td
                    style={{ textAlign: "center", borderBottom: "solid 1px" }}
                  >
                    {moment(fechaFirma).format("MM")}
                  </td>
                  <td style={{ textAlign: "center" }}>del año</td>
                  <td
                    style={{ textAlign: "center", borderBottom: "solid 1px" }}
                  >
                    {moment(fechaFirma).format("YYYY")}
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
